import type { AparenciaDoCatalogo } from "@bookdental/schemas";
import { ContatosDoCatalogo, temContatos } from "./ContatosDoCatalogo";

type Props = {
  aparencia: AparenciaDoCatalogo;
  nome: string;
  logoUrl: string | null;
  capaUrl: string | null;
  destaque: string;
};

/**
 * Primeira folha do PDF: logo, nome, título e apresentação sobre a cor de destaque ou a imagem
 * enviada (com uma camada escura, pra o texto branco se ler sobre qualquer foto). Na tela, um
 * bloco de destaque no topo. Na impressão cobre a 1ª folha A4 inteira: 297mm de altura, mas ocupa
 * 296mm no fluxo (margem de −1mm), pra o arredondamento não empurrar 1px pra uma folha vazia.
 */
export function CapaDoCatalogo({ aparencia, nome, logoUrl, capaUrl, destaque }: Props) {
  const { capa } = aparencia;
  const comImagem = capa.estilo === "imagem" && !!capaUrl;

  return (
    <section
      className="relative mb-8 flex min-h-[340px] flex-col justify-center overflow-hidden rounded-xl px-8 py-12 text-white print:z-10 print:mb-[-1mm] print:h-[297mm] print:rounded-none print:px-[20mm] print:py-[28mm] print:break-after-page"
      style={{ backgroundColor: destaque }}
    >
      {comImagem && (
        <>
          <img src={capaUrl!} alt="" className="absolute inset-0 h-full w-full object-cover" />
          <div aria-hidden className="absolute inset-0 bg-black/45" />
        </>
      )}
      <div className="relative max-w-xl space-y-4">
        {logoUrl && <img src={logoUrl} alt="" className="h-24 w-24 rounded-2xl bg-white object-contain p-2" />}
        <div>
          <h1 className="text-4xl font-bold leading-tight">{nome}</h1>
          <p className="mt-1 text-lg font-medium opacity-90">{capa.titulo || "Catálogo de serviços"}</p>
        </div>
        {capa.texto && <p className="whitespace-pre-line text-sm leading-relaxed opacity-90">{capa.texto}</p>}
      </div>
      {temContatos(aparencia.contatos) && (
        <ContatosDoCatalogo contatos={aparencia.contatos} className="relative mt-10 text-sm font-medium opacity-90 print:absolute print:bottom-[20mm] print:left-[20mm] print:right-[20mm]" />
      )}
    </section>
  );
}
